import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Text } from 'lib/common/text';
import { Flex } from 'lib/components/Flex';

const isNegativeFn = ({ isNegative, theme }) => ({
    color: isNegative ? theme.color.red : theme.color.green,
});

export const TrendBase = styled.div`
    ${isNegativeFn};
`;
export const TrendRoot = styled(Flex)`
    margin: 10px;
    text-align: right;
    align-items: baseline;
    justify-content: flex-end;
`;

TrendBase.propTypes = {
    isNegative: PropTypes.bool,
};

TrendBase.defaultProps = {
    blacklist: ['isNegative'],
};

export const Value = styled(Text)`
    ${isNegativeFn};
`;

Value.propTypes = {
    isNegative: PropTypes.bool,
};

const icon = styled.div`
    display: inline-block;
    width: 10px;
    height: 10px;
    font-size: 10px;
    margin-left: 6px;
`;
export const UpIcon = styled(icon)`
    &:before {
        content: '\\25B2';
    }
`;
export const DownIcon = styled(icon)`
    &:before {
        content: '\\25BC';
    }
`;
